import { render, staticRenderFns } from "./ProfileChangePassword.vue?vue&type=template&id=4386147e&scoped=true"
import script from "./ProfileChangePassword.vue?vue&type=script&lang=js"
export * from "./ProfileChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4386147e",
  null
  
)

export default component.exports